import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "disabled"];
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { MenuCatalogItemPropType, MenuCatalogModifierSetPropType, MenuCatalogModifierPropType, CatalogObjectId } from '../../../../types/menu-catalog';
import CatalogItemCart from '../../CatalogItemCart';
import './CatalogItemLightboxCart.css';
var defaultProps = {
  modifierLists: [],
  modifiers: [],
  initialSelectedVariation: null,
  initialSelectedModifiers: [],
  initialSpecialInstructions: '',
  initialQuantity: 1,
  disabled: false
};
function CatalogItemLightboxCart(_ref) {
  var item = _ref.item,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var name = item.name,
    description = item.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "catalog-item-lightbox-cart"
  }, /*#__PURE__*/React.createElement(CatalogItemCart, _extends({
    item: item
  }, rest), /*#__PURE__*/React.createElement(CatalogItemCart.Title, {
    className: "item-name-title",
    title: name
  }), /*#__PURE__*/React.createElement(CatalogItemCart.Description, {
    description: description
  }), /*#__PURE__*/React.createElement(CatalogItemCart.VariationSelection, null), /*#__PURE__*/React.createElement(CatalogItemCart.ModifierSetSelections, null), /*#__PURE__*/React.createElement(CatalogItemCart.SpecialInstructions, null), /*#__PURE__*/React.createElement(CatalogItemCart.ErrorMessages, null), /*#__PURE__*/React.createElement("div", {
    className: "bottom-drawer"
  }, /*#__PURE__*/React.createElement(CatalogItemCart.QuantitySelector, null), /*#__PURE__*/React.createElement(CatalogItemCart.AddToCartButton, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cart plus",
    title: "Add item to cart."
  }), /*#__PURE__*/React.createElement(CatalogItemCart.PriceSpan, null)))));
}
CatalogItemLightboxCart.defaultProps = defaultProps;
export default CatalogItemLightboxCart;